// extracted by mini-css-extract-plugin
export default {"social_media":"styles_social_media__+ddiA"};